export default __webpack_public_path__ + "static/body-v2-05-back-length-1afaed452ba90269e2f85fbbe12e2e08.png";